import { useState } from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import HomeShowcase from '../components/HomeShowcase';
import EnquirySection from '../components/EnquirySection'; 
// 1. Import the new AI component
import AiChatSection from '../components/AiChatSection'; 

interface HomePageProps {
  mode: 'light' | 'dark';
  setMode: (mode: 'light' | 'dark') => void;
}

const HomePage = ({ mode, setMode }: HomePageProps) => {
  const [isLoggedIn, setLoggedin] = useState<boolean>(false);

  return (
    <>
      {/* <Header /> */}
      
      <HomeShowcase />

      {/* ------------------------------------------------ */}
      {/* AI CHAT ASSISTANT SECTION                        */}
      {/* ------------------------------------------------ */}
      <AiChatSection />

      {/* ------------------------------------------------ */}
      {/* REUSABLE ENQUIRY SECTION COMPONENT               */}
      {/* ------------------------------------------------ */}
      <EnquirySection />

      <Footer />
    </>
  );
};

export default HomePage;